/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccountCourseAttendanceDto } from '../models/AccountCourseAttendanceDto';
import type { CourseDto } from '../models/CourseDto';
import type { CourseDtoListResult } from '../models/CourseDtoListResult';
import type { CourseUserDto } from '../models/CourseUserDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CourseService {

    /**
     * @param version 
     * @returns CourseDtoListResult OK
     * @throws ApiError
     */
    public static getCourses(
version: string,
): CancelablePromise<CourseDtoListResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/Course',
            path: {
                'version': version,
            },
        });
    }

    /**
     * @param id 
     * @param version 
     * @returns CourseDto OK
     * @throws ApiError
     */
    public static getCourseById(
id: number,
version: string,
): CancelablePromise<CourseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/Course/{id}',
            path: {
                'id': id,
                'version': version,
            },
        });
    }

    /**
     * @param courseId 
     * @param userId 
     * @param version 
     * @returns any OK
     * @throws ApiError
     */
    public static registerInCourse(
courseId: number,
userId: number,
version: string,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/Course/{courseId}/{userId}',
            path: {
                'courseId': courseId,
                'userId': userId,
                'version': version,
            },
        });
    }

    /**
     * @param courseId 
     * @param version 
     * @returns CourseUserDto OK
     * @throws ApiError
     */
    public static getCourseUsers(
courseId: number,
version: string,
): CancelablePromise<Array<CourseUserDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/Course/{courseId}/Users',
            path: {
                'courseId': courseId,
                'version': version,
            },
        });
    }

    /**
     * @param version 
     * @returns AccountCourseAttendanceDto OK
     * @throws ApiError
     */
    public static getAttendanceHistory(
version: string,
): CancelablePromise<Array<AccountCourseAttendanceDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/Course/Attendance/History',
            path: {
                'version': version,
            },
        });
    }

}
